export default __webpack_public_path__ + "static/media/api-icon.59cab2e4.png";